import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

class IFrame extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    content: PropTypes.string,
    onDocumentUpdate: PropTypes.func
  }

  static defaultProps = {
    onDocumentUpdate: () => {}
  }

  iframe = React.createRef();

  componentDidMount() {
    this.updateContent();
  }

  componentDidUpdate(previousProps) {
    if (this.props.content !== previousProps.content) {
      this.updateContent();
    }
  }

  updateContent() {
    const doc = get(this.iframe.current, 'contentWindow.document');
    if (doc) {
      doc.open();
      doc.write(this.props.content);
      doc.close();
      this.props.onDocumentUpdate(doc);
    }
  }

  render() {
    return <iframe className={this.props.className} ref={this.iframe} />;
  }
}

export default IFrame;
